module.exports = __webpack_public_path__ + "static/media/analysis.8d68ffc8.svg";